import { Pipe, PipeTransform } from '@angular/core';
import { PersonalizationPerson } from '@platform-frontend/checkout';

@Pipe({
  name: 'selectedPersonCard'
})
export class SelectedPersonCardPipe implements PipeTransform {
  transform(persons: PersonalizationPerson<string | null>[]): string {
    return persons
      .filter(person => person.fullName)
      .map(person => person.fullName)
      .join(' · ');
  }
}
